import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://passswords.visssible.com/backend';

const handleResponse = (response) => {
  const { success, data, message } = response.data;

  if (!success) {
    throw new Error(message || 'Request failed');
  }

  return data;
};

const handleRequest = async (request) => {
  try {
    const response = await request();
    return handleResponse(response);
  } catch (error) {
    const message = error.response?.data?.message;
    throw new Error(message || error.message || 'Request failed');
  }
};

export const fetchDocuments = async () => {
  return handleRequest(() => axios.get(`${API_BASE_URL}/documents-list.php`));
};

export const createDocument = async (payload) => {
  return handleRequest(() => axios.post(`${API_BASE_URL}/documents-insert.php`, payload));
};

export const updateDocument = async (id, payload) => {
  return handleRequest(() =>
    axios.post(`${API_BASE_URL}/documents-update.php`, {
      id,
      ...payload,
    })
  );
};

export const deleteDocument = async (id) => {
  return handleRequest(() => axios.post(`${API_BASE_URL}/documents-delete.php`, { id }));
};
